import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconName, withToggleableOverlay } from '@optimus-web/core';
import { NotificationType } from '../constants';
import { NavbarIconButton } from '../../../components';
import {
    getUnreadMessageNotificationsCount,
    getUnreadSystemNotificationsCount,
    getProfileMessageNotifications,
    getProfileSystemNotifications,
} from '../selectors';
import { openMessages } from '../actions/handlers';
import NotificationList from './NotificationList';

const TopMenuOverlay = (InnerContent: $TSFixMe) =>
    withToggleableOverlay({
        // @ts-expect-error $TSFixMeError: Type 'string' is not assignable to type 'never'.
        handleProps: ['count', 'title', 'icon'],
        componentProps: [
            // @ts-expect-error $TSFixMeError: Type 'string' is not assignable to type 'never'.
            'scopes',
            // @ts-expect-error $TSFixMeError: Type 'string' is not assignable to type 'never'.
            'scopeNotificationSelector',
            // @ts-expect-error $TSFixMeError: Type 'string' is not assignable to type 'never'.
            'notificationType',
            // @ts-expect-error $TSFixMeError: Type 'string' is not assignable to type 'never'.
            'icon',
            // @ts-expect-error $TSFixMeError: Type 'string' is not assignable to type 'never'.
            'title',
            // @ts-expect-error $TSFixMeError: Type 'string' is not assignable to type 'never'.
            'onScopeTitleAction',
            // @ts-expect-error $TSFixMeError: Type 'string' is not assignable to type 'never'.
            'showMessageContextMenu',
        ],
    })({
        HandleComponent: NavbarIconButton,
        ContentComponent: InnerContent,
    });

const TopMenuDropdown = (InnerContent: $TSFixMe) => {
    const Overlay = TopMenuOverlay(InnerContent);
    // @ts-expect-error $TSFixMeError: JSX element type 'Overlay' does not have any construct or call signatures.
    const Dropdown = (props: $TSFixMe) => <Overlay {...props} />;
    return Dropdown;
};

export const MessageNotificationsDropdown = connect(
    createStructuredSelector({
        count: getUnreadMessageNotificationsCount,
    }),
    {},
    (stateProps, dispatchProps, ownProps) => ({
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        showMessageContextMenu: true,
        onScopeTitleAction: openMessages,
        icon: IconName.Mails,
        notificationType: NotificationType.Message,
        title: <LocalizedText textKey={TextKey.MessagePlural} />,
        scopeNotificationSelector: getProfileMessageNotifications,
    })
)(TopMenuDropdown(NotificationList));

export const SystemNotificationsDropdown = connect(
    createStructuredSelector({
        count: getUnreadSystemNotificationsCount,
    }),
    {},
    (stateProps, dispatchProps, ownProps) => ({
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        icon: IconName.Notifications,
        notificationType: NotificationType.System,
        title: <LocalizedText textKey={TextKey.NotificationPlural} />,
        scopeNotificationSelector: getProfileSystemNotifications,
    })
)(TopMenuDropdown(NotificationList));
